// extracted by mini-css-extract-plugin
export var addButton = "_jd-0";
export var border = "_jd-8";
export var check = "_jd-h";
export var danger = "_jd-6";
export var dropdownContainer = "_jd-1";
export var editModalBody = "_jd-j";
export var footerContainer = "_jd-i";
export var fullWidth = "_jd-a";
export var hide = "_jd-9";
export var icon = "_jd-3";
export var input = "_jd-7";
export var inputFlex = "_jd-b";
export var inputWrapper = "_jd-c";
export var manualFocus = "_jd-5";
export var optionButton = "_jd-4";
export var pillWrapper = "_jd-e";
export var pointer = "_jd-2";
export var showOverflow = "_jd-f";
export var tagsFlex = "_jd-d";
export var xButton = "_jd-g";